// Enum for static patient menu item IDs
export enum PatientMenuItemId {
    REVIEW_PAST_NOTES = 'review_past_notes',
    REVIEW_PAST_NOTES_ALL = 'review_past_notes_all',
    REVIEW_PAST_NOTES_VISIT_NOTES = 'review_past_notes_visit_notes',
    REVIEW_PAST_NOTES_MESSAGES = 'review_past_notes_messages',
    REVIEW_PAST_NOTES_RESULTS = 'review_past_notes_results',
    REVIEW_PAST_NOTES_ASSESSMENT_FORMS = 'review_past_notes_assessment_forms',
    REVIEW_PAST_NOTES_ATTACHMENTS = 'review_past_notes_attachments',
    REVIEW_PAST_NOTES_EPISODES_OF_CARE = 'review_past_notes_episodes_of_care',
    REVIEW_PAST_NOTES_VISITS_BY_DIAGNOSIS = 'review_past_notes_visits_by_diagnosis',
    REVIEW_PAST_NOTES_VISITS_BY_RELATED_CASE = 'review_past_notes_visits_by_related_case',
    REVIEW_PAST_NOTES_PRINT_OPTIONS = 'review_past_notes_print_options',
}

// Extract union of all enum values (string literals)
type PatientMenuItemIdValues = `${PatientMenuItemId}`;

// For dynamic submenu IDs (e.g., review_past_notes_visits_by_diagnosis_submenu1)
type DynamicPatientMenuItemId = `${PatientMenuItemIdValues}_${string}`;

// Union type for all valid menu IDs (static + dynamic)
export type PatientMenuId = PatientMenuItemIdValues | DynamicPatientMenuItemId;
